module.exports = __webpack_public_path__ + "static/media/ceilings_lcs_10y_y.23aae416.csv";